import BlockBase from '@components/dnd/base/blockBase';
import { ColumnComp } from '@components/trace/column/column.comp';
import { useAtom } from '@hooks/useAtom';
import EndControlsFB, {
  type SettingsConfig
} from '@library/formBuilder/endControls';
import { MultiSelectEditor } from '@library/tableEditor/editors/multiSelect.editor';
import { type DNDBlock, ResolvedVariableType } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { initialSelectData } from './multiSelect.data';
import { MultiSelectSettingsModal } from './multiSelect.settings';
import { MultiSelectIcon } from './multiSelect.utils';

const MultiSelectTableEditorBlock = (block: DNDBlock) => {
  const actionId = useParams()[ParamsList.ActionId] as string;

  const atom = useAtom({
    type: 'Table_Editor_MultiSelect',
    sourceId: block.id,
    parentId: actionId,
    parentKind: 'table_editor',
    initialData: initialSelectData,
    variableInfo: {
      resolvedType: ResolvedVariableType.List
    }
  });

  if (!atom) {
    return null;
  }

  const getModalSettings = (): SettingsConfig => ({
    title: atom.data.title || 'MultiSelect Column Title',
    content: <MultiSelectSettingsModal atom={atom} />
  });

  const getEndControls = () => (
    <EndControlsFB
      dataItem={atom}
      dndBlock={block}
      hasRequired
      settings={getModalSettings()}
    />
  );
  return (
    <BlockBase
      dataItem={atom}
      dndBlock={block}
      endControls={getEndControls()}
      icon={MultiSelectIcon}
      title={atom.data.title}
    >
      <ColumnComp
        atomId={atom.id}
        isDisplayedByDefault={atom.data.isDisplayedByDefault}
        isfixedColumn={atom.data.isfixedColumn}
        onDisplayByDefaultChange={v => (atom.data.isDisplayedByDefault = v)}
        onFixedColumnChange={v => (atom.data.isfixedColumn = v)}
        onTitleChange={v => (atom.data.title = v)}
        onWidthChange={v => (atom.data.width = v)}
        title={atom.data.title}
        width={atom.data.width}
      />
      <MultiSelectEditor atom={atom} />
    </BlockBase>
  );
};

export default observer(MultiSelectTableEditorBlock);
